import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import AccordionItem from './AccordionItem';
import ProducerNotes from '../../objects/producerNotes/ProducerNotes';
import NotReadyYet from '../../objects/producerNotes/NotReadyYet';
import Button from '../../buttons/Button';//eslint-disable-line import/no-named-as-default
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appDataActions from '../../../actions/appDataActions';
import * as userDataActions from '../../../actions/userDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as dataHelper from '../../../helpers/dataHelper';
import * as appConstants from '../../../constants/appConstants';
import * as objectConstants from '../../../constants/objectConstants';
import * as localStorage from '../../../localStorage/localStorage';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as navigationHelper from '../../../helpers/navigationHelper';
import * as enviromentHelper from '../../../helpers/environmentHelper';
import {getScreenComponentByType} from '../../../helpers/componentHelper';
import _ from 'lodash';
import * as keyboardConstants from "../../../constants/keyboardConstants";
import * as animationHelper from "../../../helpers/animationHelper";

class AccordionScreen extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            screen: this.props.screen,
            userData: this.props.userData,
            showContentOutlineInPreview: props.showContentOutlineInPreview,
            locale: appHelper.getLocalData(this.props.screen),
            status: userDataHelper.getScreenUserData(this.props.userData, this.props.screen.screen_id).status,// objectConstants.STATUS_IN_PROGRESS,
            callbacks: {},
            assets: {
                background: {
                    src: "",

                },
                hotspotBackground: {
                    src: "",
                }
            },
            activeScreen: {
                screen_id: 0
            },
            renderedScreen: {},
            enabledScreens: [],
            completeScreens: [],
            toggleAllItems: false,
            isAnimating: false,
            producerNotes: appHelper.getScreenNotes(undefined, this.props.screen, this.props.showContentOutlineInPreview, props.contentData.experience.is_preview),
            screenIsReady: this.props.screen.sub_screens.length > 0 ,//&& appHelper.canSeeContent(this.props.screen),
            allowClippedBlurEffect: appHelper.allowClippedBlurEffect(),
            isOpenNavigation: appHelper.getBiteById(this.props.biteCallbacks.getBiteId()).navigation_type === objectConstants.PROGRESSION_TYPE_OPEN,
            continue_label: appHelper.getLocaleString("continue_label"),
            setNextButton: userDataHelper.getScreenUserData(this.props.userData, this.props.screen.screen_id).status === objectConstants.STATUS_COMPLETE,
            hasScreenBanner: false,
            bannerIsMaxSize: enviromentHelper.getEnvironment().window.orientation === objectConstants.ORIENTATION_PORTRAIT,
            env: enviromentHelper.getEnvironment(),
        };
        this.getScreenId = this.getScreenId.bind(this);
        this.getBiteId = this.getBiteId.bind(this);
        this.getAssets = this.getAssets.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.checkScreenStatus = this.checkScreenStatus.bind(this);
        this.setCallbacks = this.setCallbacks.bind(this);
        this.setEnabledTabs = this.setEnabledTabs.bind(this);
        this.setTabActive = this.setTabActive.bind(this);
        this.setRenderedScreen = this.setRenderedScreen.bind(this);
        this.onSubScreenComplete = this.onSubScreenComplete.bind(this);
        this.goToNextSubScreen = this.goToNextSubScreen.bind(this);
        this.hasNextSubScreen = this.hasNextSubScreen.bind(this);
        this.checkScreenComplete = this.checkScreenComplete.bind(this);
        this.updateScreenResults = _.debounce(this.updateScreenResults.bind(this), 300);
        this.setScreenAccessed = _.debounce(this.setScreenAccessed.bind(this), 300);
        this.navigateToNextScreen = this.navigateToNextScreen.bind(this);
        this.toggleAccordion = this.toggleAccordion.bind(this);
        this.onItemsClosed = this.onItemsClosed.bind(this);
        this.setIsAnimating = this.setIsAnimating.bind(this);
        this.scrollTo = this.scrollTo.bind(this);
        this.completeScreen = this.completeScreen.bind(this);
        this.setScreenNotReadyYet = this.setScreenNotReadyYet.bind(this);
        this.getCanScrollScreenClass = this.getCanScrollScreenClass.bind(this);
        this.getPanelStyle = this.getPanelStyle.bind(this);
        this.getFeedClass = this.getFeedClass.bind(this);
        this.getNextlessonLocation = this.getNextlessonLocation.bind(this);
        this.handleNextButton = this.handleNextButton.bind(this);
        this.getContinueState = this.getContinueState.bind(this);
        this.setButtonColour = this.setButtonColour.bind(this);
        this.scaleBanner = this.scaleBanner.bind(this);
        this.resizeWatcher = this.resizeWatcher.bind(this);

        this.continueBtn =  React.createRef();
        this.bannerImage = React.createRef();
        this.feed = React.createRef();
    }


    componentDidMount() {
        window.addEventListener("resize", this.resizeWatcher);
        this.props.actions.setNextButtonState(false);
        this.setScreenAccessed();
        this.props.biteCallbacks.showHeader(true);
        this.props.actions.setScreenTitle(this.state.locale.title);
        this.getAssets();
        this.setCallbacks();

        if (this.state.screenIsReady) {
            this.setEnabledTabs();
            this.checkScreenStatus();
        } else {
            this.setScreenNotReadyYet();
        }

    }

    componentWillReceiveProps(nextProps) {
        let screenUserData = userDataHelper.getScreenUserData(nextProps.userData, this.state.screen.screen_id);
        if (screenUserData.status === objectConstants.STATUS_COMPLETE) {
            this.setState({
                status: screenUserData.status,
                enabledScreens: screenUserData.status === objectConstants.STATUS_COMPLETE ? this.state.screen.sub_screens : this.state.enabledScreens,
                completeScreens: screenUserData.status === objectConstants.STATUS_COMPLETE ? this.state.screen.sub_screens : this.state.completedScreens,
                setNextButton: true,
            });
        } else if (this.state.isOpenNavigation) {
            this.setState({
                enabledScreens: Object.assign([], this.state.screen.sub_screens)
            });
        }
        this.setState({userData: Object.assign({}, nextProps.userData)});

        if (this.state.lang !== nextProps.lang) {
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screen),
                continue_label: appHelper.getLocaleString("continue_label")
            });
            this.props.actions.setScreenTitle(appHelper.getLocalData(this.state.screen).title);
        }


        if (this.state.showContentOutlineInPreview !== nextProps.showContentOutlineInPreview) {
            this.setState({
                showContentOutlineInPreview: nextProps.showContentOutlineInPreview,
                producerNotes: appHelper.getScreenNotes(undefined, this.state.screen, nextProps.showContentOutlineInPreview, this.props.contentData.experience.is_preview),
            });
        }
    }

    componentDidUpdate() {
        if (typeof this.state.renderedScreen.data === "undefined" && typeof this.state.activeScreen.screen_id !== "undefined") {
            this.setRenderedScreen();

        }
        if (this.state.setNextButton) {
            this.handleNextButton();
        }
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resizeWatcher);
    }

    resizeWatcher() {
        let env = enviromentHelper.getEnvironment();
        if ((env.window.size !== this.state.env.window.size || env.window.orientation !== this.state.env.window.orientation)) {
            this.setState({
                env: env,
                bannerIsMaxSize: env.window.orientation === objectConstants.ORIENTATION_PORTRAIT
            });
        }
    }

    setScreenAccessed() {
        this.props.actions.setScreenAccessed(this.state.screen);
    }

    setScreenNotReadyYet() {
        this.setState({status: objectConstants.STATUS_COMPLETE, setNextButton: true});
        this.updateScreenResults(objectConstants.STATUS_COMPLETE);
    }

    checkScreenStatus() {
        let screenUserData = userDataHelper.getScreenUserData(this.state.userData, this.state.screen.screen_id);
        if (screenUserData.status === objectConstants.STATUS_COMPLETE) {
            this.setState({
                status: screenUserData.status,
                enabledScreens: screenUserData.status === objectConstants.STATUS_COMPLETE ? this.state.screen.sub_screens : this.state.enabledScreens,
                completeScreens: screenUserData.status === objectConstants.STATUS_COMPLETE ? this.state.screen.sub_screens : this.state.completedScreens,
                setNextButton: true,
            });
        } else if (this.state.isOpenNavigation) {
            this.setState({
                enabledScreens: Object.assign([], this.state.screen.sub_screens)
            });
        }
    }

    getAssets() {
        let background = {};
        let hotspotBackground = {};

        if (appHelper.isDefined(this.state.screen.assets.background)) {
            background = appHelper.getBackgroundAsset(this.state.screen.assets.background);
        }
        if (appHelper.isDefined(this.state.screen.assets.hotspot)) {
            hotspotBackground = appHelper.getHotspotBackgroundAsset(this.state.screen.assets.hotspot);
        }
        this.setState({
            assets: Object.assign({}, this.state.assets, {
                background: appHelper.isDefined(background.src) ? background : this.state.assets.background,
                hotspotBackground: appHelper.isDefined(hotspotBackground.src) ? hotspotBackground : this.state.assets.hotspotBackground

            })
        });
        if (this.state.screen.sub_screens.length > 0) {
            if (!appHelper.isDefined(hotspotBackground.src) || (appHelper.isDefined(hotspotBackground.src) && hotspotBackground.src.length === 0)) {
                this.setTabActive(this.state.screen.sub_screens[0]);
                this.toggleAccordion(this.state.screen.sub_screens[0]);
            }
        }
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    setCallbacks() {
        this.setState({
            callbacks: Object.assign({}, this.props.biteCallbacks, {
                //onObjectComplete: this.onObjectComplete,
                getScreenId: this.getScreenId,
                getBiteId: this.getBiteId,
                onSubScreenComplete: this.onSubScreenComplete,
                goToNextSubScreen: this.goToNextSubScreen,
                hasNextSubScreen: this.hasNextSubScreen,
                toggleAccordion: this.toggleAccordion,
                onItemsClosed: this.onItemsClosed,
                setIsAnimating: this.setIsAnimating,
                scrollTo: this.scrollTo,
                completeScreen: this.completeScreen,
                //objectIsEnabled: this.objectIsEnabled,
                //objectIsComplete: this.objectIsComplete,
                //storeUserResponse: this.storeUserResponse,
                //scrollTo: this.scrollTo,
                //isReviewMode: this.isReviewMode
            })
        });
    }

    scrollTo(pos) {
        let feed = this.feed.current;
        let params = {
            ele: feed,
            duration: objectConstants.SCROLL_TO_DURATION,
            delay: 0,
            scrollTop: pos,
            callback: this.onScrollComplete
        };

        animationHelper.scrollTo(params);


        /*TweenLite.to(feed, objectConstants.SHOW_PANEL_DURATION, {
            scrollTop: pos,
            ease: Expo.easeInOut,
        }).eventCallback("onComplete", this.onScrollComplete);*/
    }

    getScreenId() {
        return this.state.screen.screen_id;
    }

    getBiteId() {
        //console.log(`getBiteId`);
        return this.props.biteCallbacks.getBiteId();
    }

    setEnabledTabs() {
        if (this.state.status !== objectConstants.STATUS_COMPLETE) {
            //if (this.state.screen.progression === objectConstants.OBJECT_PROGRESSION_LINEAR) {
            if (this.state.isOpenNavigation) {
                this.setState({
                    enabledScreens: Object.assign([], this.state.screen.sub_screens)
                });
            } else {
                this.setState({enabledScreens: dataHelper.immutablePush(this.state.enabledScreens, this.state.screen.sub_screens[0])});
            }
            //} else {
            //    this.setState({enabledObjects: Object.assign([], this.state.screen.objects)});
            // }

        } else {
            //  console.log("hello");
            this.setState(
                {
                    enabledObjects: Object.assign([], this.state.screen.objects),
                    completeObjects: Object.assign([], this.state.screen.objects),
                    checkContinueBtnState: true,
                    propsUpdated: false
                }
            );
        }
    }

    setTabActive(screen) {
        //set renderedObject to empty so that when component updates we make sure we can set it again and we get exactly what we want rendered
        this.setState({activeScreen: screen, renderedScreen: {}});
        //this.setBackButtonDisplayState(object);
        //this.setContinueButtonDisplayState(object);
    }

    setRenderedScreen() {
        let screenType = Object.assign({}, getScreenComponentByType(this.state.activeScreen.screen_type),
            {
                data: this.state.activeScreen
            }
        );

        this.setState({renderedScreen: Object.assign({}, screenType)});
    }


    toggleAccordion(screen) {
        if (appHelper.isDefined(this.state.activeScreen.screen_id)) {
            if (screen.screen_id !== this.state.activeScreen.screen_id) {
                this.setState({activeScreen: Object.assign({}, screen), toggleAllItems: true});
            } else {
                this.setState({
                    activeScreen: Object.assign({}, {
                        screen_id: 0,
                    }), toggleAllItems: true
                });
            }
        } else {
            this.setState({activeScreen: Object.assign({}, screen), toggleAllItems: true});
        }
    }

    setIsAnimating(isAnimating) {
        this.setState({isAnimating: isAnimating});
    }

    onItemsClosed() {
        this.setState({toggleAllItems: false});
    }


    onSubScreenComplete(screen) {
        //console.log(screen);
        let completionIndex = appHelper.getArrayObjectIndexByKey(this.state.completeScreens, "screen_id", screen.screen_id);
        let subScreenIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", screen.screen_id);
        let nextScreen = {};

        if (subScreenIndex < (this.state.screen.sub_screens.length - 1)) {
            nextScreen = Object.assign({}, this.state.screen.sub_screens[subScreenIndex + 1]);
        }

        if (completionIndex === -1) {
            this.setState(
                {
                    completeScreens: dataHelper.immutablePush(this.state.completeScreens, screen),
                    enabledScreens: typeof nextScreen.screen_id !== "undefined" ? dataHelper.immutablePush(this.state.enabledScreens, nextScreen) : Object.assign([], this.state.enabledScreens),
                    checkContinueBtnState: true
                }
            );
            // this.updateScreenResults(this.state.status !== objectConstants.STATUS_COMPLETE ? objectConstants.STATUS_IN_PROGRESS: objectConstants.STATUS_COMPLETE, object.object_id);
        }

        this.checkScreenComplete();
    }

    hasNextSubScreen(screen) {
        let subScreenIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", screen.screen_id);
        return subScreenIndex < (this.state.screen.sub_screens.length - 1);
    }

    goToNextSubScreen(screen) {
        let subScreenIndex = appHelper.getArrayObjectIndexByKey(this.state.screen.sub_screens, "screen_id", screen.screen_id);
        if (this.hasNextSubScreen(screen)) {
            let nextScreen = Object.assign({}, this.state.screen.sub_screens[subScreenIndex + 1]);
            this.setTabActive(nextScreen);
            this.toggleAccordion(nextScreen);
        } else {
            this.navigateToNextScreen();
        }
    }

    navigateToNextScreen() {
        if (this.state.isOpenNavigation || this.state.screen.progression === objectConstants.PROGRESSION_TYPE_EXPLORE_INTERESTS) {
            this.updateScreenResults(objectConstants.STATUS_COMPLETE);
        }

        if (appHelper.isDefined(this.state.screen.next_screen_id) && !isNaN(this.state.screen.next_screen_id)) {
            this.goToScreen(this.state.screen.next_screen_id);
        } else {
            let nextScreenId = appHelper.getNextScreenId(this.getScreenId());
            if (localStorage.bites.length > 1 && nextScreenId.length === 0) {
                this.context.router.push('menu');
            } else {
                this.props.actions.setNextLessonLocation(this.getScreenId());
            }
        }
    }

    getNextlessonLocation() {
        let next_lesson_location = 0;
        if (appHelper.isDefined(this.state.screen.next_screen_id) && !isNaN(this.state.screen.next_screen_id)) {
            next_lesson_location = this.state.screen.next_screen_id;
        } else {
            let nextScreenId = appHelper.getNextScreenId(this.getScreenId());
            if (localStorage.bites.length > 1 && nextScreenId.length === 0) {
                next_lesson_location = -1;
            } else {

                next_lesson_location = navigationHelper.getNextLessonLocation(this.getScreenId());
            }
        }

        return next_lesson_location;
    }

    handleNextButton() {
        this.setState({setNextButton: false});
        let next_lesson_location = this.getNextlessonLocation();
        if (next_lesson_location !== 0) {
            this.props.actions.setNextButtonState(true, next_lesson_location);
        }
    }

    checkScreenComplete() {
        if (this.state.completeScreens.length >= this.state.screen.sub_screens.length) {
            this.setState(
                {
                    status: objectConstants.STATUS_COMPLETE,
                    setNextButton: true,
                }
            );
            this.updateScreenResults(objectConstants.STATUS_COMPLETE);
        }
    }

    //used when child screen terminates
    completeScreen() {
        this.setState(
            {
                status: objectConstants.STATUS_COMPLETE,
                setNextButton: true,
            }
        );
        this.updateScreenResults(objectConstants.STATUS_COMPLETE);
    }

    updateScreenResults(screen_status) {
        let params = {
            bite_id: this.getBiteId(),
            screen_id: this.getScreenId(),
            screen_status: screen_status,
            object_status: objectConstants.STATUS_COMPLETE,
        };

        this.props.actions.updateScreenResults(params).then((userData) => {
            this.props.actions.setSuspendData(userData).then((trackingData) => {
                if (screen_status === objectConstants.STATUS_COMPLETE) {
                    this.props.actions.setScreenComplete(this.state.screen);
                }
            }).catch(error => {
            });
        }).catch(error => {
        });
    }

    getCanScrollScreenClass() {
        return parseFloat(this.state.activeScreen.screen_id) === 0 ? "allow-scroll" : "";
        //return "allow-scroll";
    }

    getPanelStyle() {
        return appHelper.isDefined(this.state.screen.panel_style) ? this.state.screen.panel_style : "frosted_white";

    }

    getFeedClass() {
        return this.state.allowClippedBlurEffect ? 'blurred-feed' : 'standard-feed';
    }

    getContinueState(){
        let enabled = (this.state.status === objectConstants.STATUS_COMPLETE || this.state.isOpenNavigation || this.state.screen.progression === objectConstants.PROGRESSION_TYPE_EXPLORE_INTERESTS  && this.state.screenIsReady);
        return !enabled;
    }
    setButtonColour() {
        if (this.state.screen.hotspot_type === objectConstants.HOT_SPOT_TYPE_NO_SCREEN || this.state.screen.hotspot_type === objectConstants.HOT_SPOT_TYPE_FULL_SCREEN) {
            if (this.state.screen.hotspot_colour !== objectConstants.INHERIT && this.state.screen.hotspot_label_colour !== objectConstants.INHERIT) {
                return {
                    background: `${this.state.screen.hotspot_colour} !important`,
                    color: `${this.state.screen.hotspot_label_colour} !important`
                };
            } else if (this.state.screen.hotspot_colour !== objectConstants.INHERIT && this.state.screen.hotspot_label_colour === objectConstants.INHERIT) {
                return {
                    background: `${this.state.screen.hotspot_colour} !important`

                };
            } else if (this.state.screen.hotspot_colour === objectConstants.INHERIT && this.state.screen.hotspot_label_colour !== objectConstants.INHERIT) {
                return {
                    color: `${this.state.screen.hotspot_label_colour} !important`
                };
            } else {
                return {};
            }
        } else {
            return {};
        }

    }

    scaleBanner(event) {
        event.preventDefault();
        event.stopPropagation();
        if (appHelper.isDefined(event.which)) {
            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
                this.setState({
                    bannerIsMaxSize: !this.state.bannerIsMaxSize
                });
            }
        } else {
            this.setState({
                bannerIsMaxSize: !this.state.bannerIsMaxSize
            });
        }
    }


    render() {
        let renderedScreen = this.state.renderedScreen;
        return (
            <div className="customer-scenario">
                {
                    !this.state.screen.use_bg_as_banner_on_devices || (this.state.screen.use_bg_as_banner_on_devices && this.state.env.window.orientation !== objectConstants.ORIENTATION_PORTRAIT)
                        ?
                        <div className="background-container">
                            <img src={this.getImagePath(this.state.assets.background.src)} alt=""/>
                        </div>
                        :
                        null
                }
                <div className="screen-container">
                    <div className={`accordion-screen ${this.getPanelStyle()}`}>
                        {
                            this.state.allowClippedBlurEffect && !this.state.screen.use_bg_as_banner_on_devices || (this.state.screen.use_bg_as_banner_on_devices && this.state.env.window.orientation !== objectConstants.ORIENTATION_PORTRAIT)

                                ?
                                <div className={`content-wrapper-background `}>
                                    <img className="blur" src={this.getImagePath(this.state.assets.background.src)}
                                         alt=""/>

                                </div>
                                :
                                null
                        }
                        <div
                            className={`accordion-content-wrapper ${this.getFeedClass()}  ${this.getCanScrollScreenClass()}`}
                            ref={this.feed}>
                            {
                                appHelper.isDefined(this.state.assets.hotspotBackground.src) && this.state.assets.hotspotBackground.src.length > 0 && appHelper.isDefined(this.state.screen.sub_screens) && this.state.screen.sub_screens.length > 0
                                    ?
                                    <div className="background-image">
                                        <img className={`hot-spot-background`}
                                             src={this.getImagePath(this.state.assets.hotspotBackground.src)} alt=""/>
                                        <button className={`btn guroo-btn hot-spot-continue-btn`} onClick={this.navigateToNextScreen} disabled={this.getContinueState()}
                                                style={this.setButtonColour()} ref={this.continueBtn}>{this.state.continue_label}</button>
                                    </div>
                                    :
                                    null
                            }

                            {
                                this.state.screen.use_bg_as_banner_on_devices && this.state.env.window.orientation === objectConstants.ORIENTATION_PORTRAIT
                                    ?
                                    <div className="background-banner" onClick={this.scaleBanner}
                                         onKeyDown={this.scaleBanner} role="link" tabIndex={0}>
                                        <div className={`banner-image`}>
                                            <img src={this.getImagePath(this.state.assets.background.src)} alt=""/>
                                        </div>

                                    </div>
                                    :
                                    null
                            }


                            <div className="accordion">
                                {appHelper.isDefined(this.state.screen.sub_screens)

                                    ?
                                    this.state.screen.sub_screens.map(sub_screen =>
                                        typeof this.state.activeScreen.screen_id !== "undefined" && this.state.screenIsReady
                                            ?
                                            <AccordionItem key={`${sub_screen.screen_id}_tab`}
                                                           parentScreen={this.state.screen}
                                                           screen={sub_screen}
                                                           activeScreenId={parseInt(this.state.activeScreen.screen_id)}
                                                           enabledScreens={this.state.enabledScreens}
                                                           completeScreens={this.state.completeScreens}
                                                           toggleAllItems={this.state.toggleAllItems}
                                                           isAnimating={this.state.isAnimating}
                                                           biteCallbacks={this.state.callbacks}/>
                                            : null
                                    )
                                    : null
                                }
                                {
                                    !this.state.screenIsReady
                                        ?
                                        <div>
                                            {
                                                !this.state.screenIsReady
                                                    ?
                                                    <NotReadyYet screen_id={this.state.screen.screen_id}
                                                                 onContinue={this.navigateToNextScreen}/>
                                                    :
                                                    null

                                            }
                                            {
                                                this.state.producerNotes.show_notes
                                                    ?
                                                    <ProducerNotes notes={this.state.producerNotes.notes}
                                                                   screen_id={this.state.screen.screen_id}/>
                                                    :
                                                    null
                                            }

                                        </div>
                                        :
                                        null
                                }
                            </div>


                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

/*
* <div className="tabbed-body-content" ref={`${this.state.screen.screen_id}_feed`}>
                            {typeof renderedScreen.data !== "undefined"
                                ?
                                <renderedScreen.component screen={renderedScreen.data} parentScreen={this.state.screen}
                                                          biteCallbacks={this.state.callbacks}/>
                                : null
                            }
                        </div>
* */

AccordionScreen.propTypes = {
    screen: PropTypes.object.isRequired,
    biteCallbacks: PropTypes.object.isRequired,
    titles: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    contentData: PropTypes.object.isRequired,
    showContentOutlineInPreview: PropTypes.bool.isRequired,
};

AccordionScreen.contextTypes = {
    router: PropTypes.object,

};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang: lang,
        contentData: state.contentData,
        titles: state.titles,
        userData: state.userData,
        showContentOutlineInPreview: state.showContentOutlineInPreview,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions, userDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AccordionScreen);



/** WEBPACK FOOTER **
 ** ./src/components/screens/accordionScreen/AccordionScreen.js
 **/